import { createSlice } from "@reduxjs/toolkit";
import { ActionSectionIcons } from "AssortmentOverview/ProductSection/Header/ActionSection/types";
import { ProductSectionView } from "AssortmentOverview/ProductSection/types";
import productSectionReducers from "./reducers";

export const initialState = {
  activeView: ProductSectionView.LIST_PRODUCT,
  shouldShowDoorsModal: false,
  shouldShowImportModal: false,
  deleteProductsEnabled: false,
  disabledActions: [] as ActionSectionIcons[],
  selectedRows: [] as any[],
  rowsDeleted: [] as any[],
  newStyleColorRows: [] as any[],
  workspaceAssistantEnabled: false,
};
const productSectionSlice = createSlice({
  name: "productSection",
  initialState,
  reducers: productSectionReducers,
});

const { actions } = productSectionSlice;
export { actions };

export default productSectionSlice;
